import { useCallback, useRef } from 'react';

import useOutsideClick from '../../../hooks/useOutsideClick';

import {
  ModalBody,
  ModalBodyContainter,
  ModalHeader,
  ModalSubmitButton,
  ModalTitle,
  StyledModal,
  StyledModalContent,
} from './modal.style';
import IconButton from '../iconButton';
import { IntlMessages } from '../../../helper/langHelper';
import { AddPlusIcon, CloseIconRed } from '../../icons';

const Modal = (props) => {
  const {
    isOpen = false,
    onClose = () => {},
    onOpen = () => {},
    children,
    title = '',
    color = 'primary',
    submitBtnText = 'Save',
    isBtnEnabled = false,
    isNotCapitalize,
    isClosedButton = false,
    icon,
    isHeader = 'true',
    isUppercase = false,
    overFlowVisible = false,
    isCrossButton = false,
  } = props;
  const node = useRef(null);
  useOutsideClick({
    isOpen: isOpen,
    node,
    onOutsideClick: onClose,
  });

  const handleCloseModal = useCallback(() => {
    onClose();
  }, [onClose]);

  document.onkeydown = (e) => {
    e = e || window.event;
    if (e.keyCode === 27) {
      handleCloseModal();
    }
  };

  // const renderCloseButton = () => {
  //   return (
  //     <CloseButton varient="normal" onClick={handleCloseModal}>
  //       <CloseIconRedNew />
  //     </CloseButton>
  //   );
  // };

  const onClick = useCallback(() => {
    handleCloseModal();
  }, [handleCloseModal]);

  return (
    <>
      <StyledModal isOpen={isOpen}>
        <StyledModalContent ref={node}>
          <ModalBodyContainter
            color={color}
            className="hide-scroll-bar"
            overFlowVisible={overFlowVisible}
          >
            <ModalBody>
              {title && isHeader && (
                <ModalHeader>
                  <ModalTitle
                    size="header3"
                    isNotCapitalize={isNotCapitalize}
                    isUppercase={isUppercase}
                  >
                    {title}
                  </ModalTitle>
                  {!isClosedButton && icon}
                  {isClosedButton && (
                    <IconButton
                      text={<IntlMessages id="modal.button.text" />}
                      icon={<AddPlusIcon />}
                      onClick={onOpen}
                    />
                  )}
                  {isCrossButton && (
                    <>
                      <CloseIconRed onClick={onClose} style={{ cursor: 'pointer' }} />
                    </>
                  )}
                </ModalHeader>
              )}
              {children}
            </ModalBody>
          </ModalBodyContainter>
          {isBtnEnabled && (
            <ModalSubmitButton color={'primary'} onClick={onClick}>
              {submitBtnText}
            </ModalSubmitButton>
          )}
        </StyledModalContent>
      </StyledModal>
    </>
  );
};

export default Modal;
